module.exports = __webpack_public_path__ + "img/search.ef2d071c.svg";